var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-input',{attrs:{"type":"text","inputmode":"text","pattern":"text","required":_vm.field.required,"value":_vm.value.value},on:{"ionInput":function($event){_vm.value.value = $event.target.value}}})}
var staticRenderFns = []

export { render, staticRenderFns }